import { LegendSection } from '../components/IconLegendModal';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { NEW_PRO_ROW_CLASS, STORAGE_CLEARED_ROW_CLASS } from './schedulingRowClass';

export const schedulerLegendSections: LegendSection[] = [
  {
    title: 'Row Colors',
    items: [
      {
        icon: <div className={`w-6 h-6 rounded border border-gray-300 dark:border-gray-600 ${NEW_PRO_ROW_CLASS}`} />,
        title: 'New PRO',
        description: 'Newly arrived — added to the board since you last looked',
      },
      {
        icon: <div className={`w-6 h-6 rounded border border-gray-300 dark:border-gray-600 ${STORAGE_CLEARED_ROW_CLASS}`} />,
        title: 'Storage Cleared',
        description: 'Storage has been paid — a cleared-through date is on file AND a storage Additional Cost record has a line item marked PAY. Prioritize scheduling these first.',
      },
    ],
  },
  {
    title: 'Flags',
    items: [
      {
        icon: (
          <div className="flex gap-2 items-center">
            <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white rounded bg-orange-500">1</span>
            <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white rounded bg-red-500">2+</span>
          </div>
        ),
        title: 'Service Failure Count',
        description: 'Orange = 1 service failure, Red = 2+ service failures. Hover for history.',
      },
      {
        icon: <ExclamationTriangleIcon className="w-6 h-6 text-red-500" />,
        title: 'Missing Weight',
        description: 'Order weight is missing or zero',
      },
      {
        icon: <span className="inline-flex items-center justify-center px-1 h-6 text-xs font-bold text-white rounded bg-red-600">NO HAZ DOCS</span>,
        title: 'Missing Hazmat Paperwork',
        description: 'Haz=Y order with no HAZ-MAT PAPERWORK document uploaded. Finalize is blocked until it is.',
      },
      {
        icon: <span className="inline-flex items-center justify-center px-1 h-6 text-xs font-bold text-white rounded bg-green-600">COD</span>,
        title: 'COD',
        description: 'Cash on delivery — payment collected at delivery',
      },
      {
        icon: <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white rounded bg-blue-600">B</span>,
        title: 'Bonded Cargo',
        description: 'In-bond shipment. Hover the flag to see the in-bond type (e.g. T&E, IT, IE).',
      },
    ],
  },
  {
    title: 'Order Requirements',
    items: [
      {
        icon: <span className="gw-icon gw-icon-hotjar text-red-500" style={{ fontSize: '24px' }}></span>,
        title: 'HOT Load',
        description: 'Time-sensitive shipment requiring priority handling',
      },
      {
        icon: <span className="flaticon flaticon-warning text-orange-500" style={{ fontSize: '24px' }}></span>,
        title: 'Hazmat',
        description: 'Hazmat endorsement required',
      },
      {
        icon: <span className="flaticon flaticon-weight text-heading" style={{ fontSize: '24px' }}></span>,
        title: 'Overweight',
        description: 'Overweight permit required (over 44,000 lbs)',
      },
      {
        icon: <span className="gw-icon gw-icon-early text-heading" style={{ fontSize: '24px' }}></span>,
        title: 'Early',
        description: 'Early appointment (before 10:00 AM)',
      },
      {
        icon: <span className="gw-icon gw-icon-dual-axle text-blue-600" style={{ fontSize: '24px' }}></span>,
        title: 'Triaxle',
        description: 'Triaxle chassis required',
      },
      {
        icon: <span className="gw-icon text-heading" style={{ fontSize: '24px' }}>&#xE9E5;</span>,
        title: '93K',
        description: '93K triaxle chassis required',
      },
      {
        icon: <span className="flaticon flaticon-cargo text-purple-600" style={{ fontSize: '24px' }}></span>,
        title: 'Swing',
        description: 'Swing container',
      },
      {
        icon: <span className="flaticon flaticon-oil-tank text-purple-600" style={{ fontSize: '24px' }}></span>,
        title: 'Tank',
        description: 'Tank endorsement required',
      },
      {
        icon: <span className="gw-icon gw-icon-daycab text-blue-700" style={{ fontSize: '24px' }}></span>,
        title: 'Daycab',
        description: 'Daycab truck required',
      },
      {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" className="text-blue-500 fill-current">
            <path d="M11,24c-6.079.117-9.334-7.638-5-11.89V5c.211-6.609,9.791-6.6,10,0v7.11C20.335,16.363,17.077,24.117,11,24ZM11,2A3,3,0,0,0,8,5v7.537a1,1,0,0,1-.332.744A5.018,5.018,0,0,0,11,22a5.018,5.018,0,0,0,3.332-8.719A1,1,0,0,1,14,12.537V5A3,3,0,0,0,11,2Zm0,18a3.007,3.007,0,0,1-1-5.829V12a1,1,0,0,1,2,0v2.171A3.007,3.007,0,0,1,11,20Zm0-4a1,1,0,0,0,0,2A1,1,0,0,0,11,16ZM21,6a3,3,0,0,1,0-6A3,3,0,0,1,21,6Zm0-4a1,1,0,0,0,0,2A1,1,0,0,0,21,2Z"/>
          </svg>
        ),
        title: 'Reefer',
        description: 'Temperature controlled container',
      },
    ],
  },
];
